import { z } from 'zod';
/**
 * Shape returned by GET /health on the API.
 * Both the API and the web consume this through @wharf/shared.
 */
export const HealthResponseSchema = z.object({
    status: z.enum(['ok', 'degraded', 'down']),
    version: z.string(),
    uptimeSeconds: z.number().int().nonnegative(),
    checks: z.object({
        postgres: z.enum(['ok', 'down']),
        valkey: z.enum(['ok', 'down']),
    }),
});
//# sourceMappingURL=health.js.map